import request from '@/utils/service'

export function list(data) {
  return request({
    url: '/card/list',
    method: 'get',
    params: data
  })
}

export function orderList(data) {
  return request({
    url: '/card/OrderList',
    method: 'get',
    params: data
  })
}

export function delCard(data) {
  return request({
    url: '/card/delete',
    method: 'post',
    data
  })
}
